import { render, staticRenderFns } from "./CostBearerEducationOtherCostsPreview.vue?vue&type=template&id=858a61a2&scoped=true"
import script from "./CostBearerEducationOtherCostsPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerEducationOtherCostsPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858a61a2",
  null
  
)

export default component.exports